module.exports = __webpack_public_path__ + "img/fondo_juegos.e8f48da8.svg";